import React from 'react';
import { TopBanner } from '../../../common/components';
import { useDegradationStatus } from '../hooks';
import { PROVIDER_LABELS } from '../labels';

/**
 * User-facing degraded-mode banner. Shown on every user page (mounted in
 * UserLayout). When a blocking provider (WRP) is OPEN/disabled it warns that
 * certificate issuance is temporarily paused; otherwise it just notes which
 * non-critical services are degraded.
 */
function DegradationBanner() {
    const { degradation, loading } = useDegradationStatus();

    if (loading || !degradation.degraded) return null;

    const names = (degradation.providers || [])
        .map((p) => PROVIDER_LABELS[p.provider] || p.provider)
        .join('، ');

    if (degradation.issuanceBlocked) {
        return (
            <TopBanner
                variant="alert"
                title={`سرویس صدور گواهی در حال حاضر موقتاً در دسترس نیست${names ? ` (${names})` : ''}. درخواست شما به صف ارسال و پس از بازیابی خودکار صادر می‌شود.`}
                testId="degradation-banner-blocking"
            />
        );
    }

    return (
        <TopBanner
            variant="info"
            title={`برخی سرویس‌های سیستم موقتاً در حالت محدود هستند${names ? ` (${names})` : ''}؛ عملیات‌ها به صورت خودکار پیگیری می‌شوند.`}
            testId="degradation-banner"
        />
    );
}

export default DegradationBanner;